import { useContext } from "react";
import { RequestLoader, ToastContext } from "./context";
import {
  cleanObject,
  getRandomIntInclusive,
  getUrlQuerysection,
} from "../helpers";
import {
  useCancelPendingSession,
  useContinuePendingSession,
  useCreatePendCheckoutSession,
} from "./api/mutations/useOrder";
import { useCart } from "./useCart";
import { useGetPendingSessions } from "./api/queries/useOrder";
import { useNavigate } from "react-router-dom";
import { useUrlSearch } from "./useUrlSearch";
import { useQueryClient } from "react-query";
import { useCheckoutHelper } from "./useCheckoutHelper";

const usePendingCheckoutSession = ({
  onPendSuccess = () => {},
  isEnabled = true,
}) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const queries = getUrlQuerysection();
  const { search, setSearch, gotoPage, filterBySearch, filterByKey } =
    useUrlSearch();
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const triggerToast = useContext(ToastContext);
  const {
    isLoading: isFetchingSessions,
    data,
    refetch: refetchPendingSessions,
  } = useGetPendingSessions({ queries, isEnabled });

  const {
    isAddingToCart,
    store_id,
    cartItems,
    setIsRefetchCart,
    checkoutInfo,
    resetOrderOncheckOut,
    handleBulkAddToCart,
  } = useCart({
    unPendSuccessCallBack: () => {
      navigate(-1);
    },
  });
  const { setCustomerInfo } = useCheckoutHelper();

  const { mutate: continueSession } = useContinuePendingSession();
  const continueCheckout = (sessionId, customer = null) => {
    if (cartItems?.length > 0)
      return triggerToast(
        "Please clear your cart before proceeding with a pended checkout",
      );

    setRequestLoaderProgress(getRandomIntInclusive(10, 40));
    continueSession(
      { id: sessionId },
      {
        onSuccess: () => {
          if (customer)
            setCustomerInfo({
              customerId: customer?.id,
              customer_id: customer?.id,
              customerPhoneNumber: customer?.phone_number,
              customerEmail: customer?.email,
              customerName: customer?.full_name,
              customerPhoneCode: customer?.phone_code,
              credit_limit: customer?.credit_limit,
            });

          setIsRefetchCart(true);
          queryClient.invalidateQueries(["getPendingSessions"]);
        },

        onSettled: () => setRequestLoaderProgress(100),
      },
    );
  };

  const { mutate: cancelSession } = useCancelPendingSession();
  const cancelCheckout = (sessionId) => {
    setRequestLoaderProgress(getRandomIntInclusive(10, 40));
    cancelSession(
      { id: sessionId },
      {
        onSuccess: () => {
          triggerToast("Session Cancelled Succesfully", "success");
          queryClient.invalidateQueries(["getPendingSessions"]);
        },

        onSettled: () => setRequestLoaderProgress(100),
      },
    );
  };

  const pendCheckoutMutation = useCreatePendCheckoutSession();
  const pendCheckout = () => {
    pendCheckoutMutation.mutate(
      cleanObject({
        store_id: store_id,
        customer_id: checkoutInfo?.customer?.customer_id,
      }),
      {
        onSuccess: () => {
          queryClient.invalidateQueries(["getPendingSessions"]);
          resetOrderOncheckOut();
          triggerToast("Session Pended!", "success");
          onPendSuccess();
        },
      },
    );
  };

  const handlePendCheckout = () => {
    handleBulkAddToCart({ onSuccess: pendCheckout });
  };

  return {
    isFetchingSessions,
    isPendingCheckout: pendCheckoutMutation?.isLoading || isAddingToCart,
    pendingSessions: data?.data || [],
    metaDetails: data?.meta || {},
    search,
    setSearch,
    gotoPage,
    filterBySearch,
    filterByKey,
    handlePendCheckout,
    continueCheckout,
    cancelCheckout,
    refetchPendingSessions,
  };
};
export default usePendingCheckoutSession;
